import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";

const FeaturedProduct = ({
  image,
  price,
  name,
  _id,
  storeCurrency,
  category,
}) => {
  return (
    <div className="feature-product border">
      <Link to={`/product/${_id}`}>
        <img src={image} alt={name} />
        <p className="text-white flex gap-2 items-center pro-icon">
          <EyeOutlined />
        </p>
      </Link>
      <div className="p-6 flex flex-col items-center justify-center">
        <h5 className="heading_h5">{category}</h5>
        <Link to={`/product/${_id}`}>
          <h4 className="heading_h4">{name}</h4>
        </Link>
        <p className="heading_h3">
          {storeCurrency} {price}
        </p>
      </div>
    </div>
  );
};

export default FeaturedProduct;
